// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dita-content-spacer[data-v-2a18b1e0]{padding:0;margin:0}img[data-v-2a18b1e0]{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
